import type { MtoRun } from '@entities/mto';
import { fmtDateTime } from '@entities/mto';

/** Человекочитаемый размер файла: 24 КБ / 1.4 МБ. */
export function fmtSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} Б`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} КБ`;
  return `${(bytes / (1024 * 1024)).toLocaleString('ru-RU', { maximumFractionDigits: 1 })} МБ`;
}

let docSeq = 0;
export function nextDocId(): string {
  docSeq += 1;
  return `mto-doc-${docSeq}`;
}

/** Заголовок обработки: краткая сводка или дата создания (summary может быть null). */
export function runTitle(run: MtoRun): string {
  return run.summary?.trim() || `Обработка от ${fmtDateTime(run.created_at)}`;
}
